import React from "react";
import PropTypes from "prop-types";

import { Label, TextValue } from "..";

export function FormFieldContent({
  name,
  required,
  description,
  type,
  value,
  prefix,
  hasAccess,
  onClick,
}) {
  return (
    <React.Fragment>
      <div
        onClick={onClick}
        style={{
          cursor: hasAccess ? "pointer" : "default",
        }}
      >
        <Label style={{ background: "#757575", color: "#FFFFFF" }}>
          {name}
        </Label>{" "}
        {required && (
          <span style={{ color: "#BF3333", marginRight: "0.5em" }}>*</span>
        )}
        <TextValue type={type} value={value} prefix={prefix} />
      </div>
      {description && (
        <div
          style={{ color: "#AAAAAA", fontSize: "12px" }}
          data-test="field-description"
        >
          {description}
        </div>
      )}
    </React.Fragment>
  );
}

FormFieldContent.propTypes = {
  name: PropTypes.string,
  type: PropTypes.object,
  required: PropTypes.bool,
  description: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.instanceOf(Date),
  ]),
  prefix: PropTypes.string,
  hasAccess: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

FormFieldContent.defaultProps = {
  name: "",
  type: null,
  description: "",
  required: true,
  value: null,
  hasAccess: false,
  prefix: "",
};

export default FormFieldContent;
